<template>
    <page-layout :readonly="isProposalAccepted" :hide-footer="isProposalAccepted">
        <template slot="header">
            <proposal-step-header
                :current-step="stepNumber"
                :total-steps="totalSteps"
                :title="assetsStepTitle"
                :use-exit-modal="false"
                :is-loading="isLoading"
            />
        </template>
        <template slot="default">
            <g-loader type="fixed" v-if="isLoading"/>
            <div v-else>
                <div v-if="campaign.assets && campaign.assets.length > 0">
                    <div class="margin-bottom-normal">
                        <g-typography tag="h4" :value="assetsStepDescription" class="break-new-line"/>
                    </div>
                    <proposal-step-error class="margin-bottom-normal" v-if="proposalStep && proposalStep.error" :step="proposalStep"/>
                    <div v-for="asset in campaign.assets" class="margin-bottom-large">
                        <float-on-mask tag="div" :float-up="isProposalAccepted">
                            <brand-asset :asset="asset"/>
                        </float-on-mask>
                    </div>
                </div>
                <div v-else>
                    <g-typography tag="h4">No assets available.</g-typography>
                </div>
            </div>
        </template>
        <template slot="footer">
            <proposal-step-footer
                :is-next-disabled="false"
                :loading="isCompletingProposal"
                :use-exit-modal="false"
                :step-completed="isCompleted"
                :current-step="stepNumber"
                :total-steps="totalSteps"
                @go-next-step="$emit('go-next-step', proposalStep)"
                @go-previous-step="$emit('go-previous-step', proposalStep)"
            />
        </template>
    </page-layout>
</template>
<script>
    import PageLayout from "../../layouts/PageLayout";
    import ProposalStepFooter from "./partials/ProposalStepFooter";
    import ProposalStepHeader from "./partials/ProposalStepHeader";
    import BrandAsset from "../../library/BrandAsset";
    import * as _ from "lodash";
    import ProposalStepError from "./partials/PoposalStepError";
    import ProposalMixin from "./mixins/ProposalMixin";
    import FloatOnMask from "../../library/FloatOnMask";

    export default {
        name: "ProposalAssetsView",
        components: {
            FloatOnMask,
            ProposalStepError,
            BrandAsset,
            PageLayout,
            ProposalStepHeader,
            ProposalStepFooter,
        },
        mixins: [
            ProposalMixin,
        ],
        props: {
            campaign: {
                type: Object,
            },
            proposal: {
                type: Object,
            },
            proposalStep: {
                type: Object,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
            isCompletingProposal: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            stepNumber() {
                return _.get(this, 'proposalStep.meta.stepNumber', 0);
            },
            totalSteps() {
                return _.get(this, 'proposalStep.meta.totalSteps', 0);
            },
            assetsStepTitle() {
                const title = _.get(this, 'campaign.customization.assets_step_title');
                const defaultTitle = 'Brand Asset' + (_.get(this, 'campaign.assets', []).length > 1 ? 's' : '');

                return title ? title : defaultTitle;
            },
            assetsStepDescription() {
                const description = _.get(this, 'campaign.customization.assets_step_overview');

                return description ? description : 'Please be sure to review these important documents.';
            },
            isCompleted() {
                return _.get(this, 'proposalStep.is_complete', false);
            },
        },
    }
</script>
<style lang="scss" scoped>
    .margin-bottom-normal {
        margin-bottom: $g-spacing-5;
    }
    .margin-bottom-large {
        margin-bottom: $g-spacing-5;
    }

    .break-new-line {
        white-space: pre-line;
    }
</style>
